import { Box, Typography } from '@mui/material';
import TileMetaActions from '../TileMetaActions';
import { getMetricDisplayName } from './rendererTypes';
import type { MetricRendererProps } from './rendererTypes';
import { tileMetaTitlePad } from '../../utils/tileMeta';

/** Title-only metric: renders API `display_name`. No cards or breakdown. */
export default function SectionTitleMetricRenderer({ config, data }: MetricRendererProps) {
  const title = getMetricDisplayName(data, config);
  if (!title) return null;

  return (
    <Box sx={{ width: '100%', position: 'relative', pr: tileMetaTitlePad(data.meta) }}>
      <TileMetaActions query={data.meta?.query} registry={data.meta?.registry} />
      <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary' }}>
        {title}
      </Typography>
    </Box>
  );
}
